import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ReactComponent as NoArticles } from 'assets/images/EmptyState/NoArticles.svg';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

export const ResourceNoArticlesState = () => {
  const { translation } = useTranslationContext();

  return (
    <Stack alignItems="center" spacing={2} sx={{ py: 6 }}>
      <NoArticles role="img" aria-label="No articles" width={240} height={250} />
      <Typography
        variant="headline"
        textAlign="center"
        fontWeight={500}
        sx={{ color: (theme) => theme.palette.primary.main }}
      >
        {translation('library_empty_state_title')}
      </Typography>
      <Typography
        variant="callout"
        textAlign="center"
        sx={{ color: (theme) => theme.palette.grey[800] }}
      >
        {translation('library_empty_state_message')}
      </Typography>
    </Stack>
  );
};

ResourceNoArticlesState.displayName = 'ResourceNoArticlesState';
